module.exports = __webpack_public_path__ + "band_13_daughter.2999abbe.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/child_to_parent/band_13_daughter.png
// module id = KQ7t
// module chunks = 0